import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const statsApi = createApi({
  reducerPath: "stats",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Stats"],
  endpoints: (builder) => ({
    getDashboardStats: builder.query({
      query: (data) => {
        const { token, ...filteredData } = data;
        return {
          url: "/api/clinic/dashboard/stats",
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: {
            ...filteredData,
          },
        };
      },
      providesTags: ["Stats"],
    }),
  }),
});

export const { useGetDashboardStatsQuery } = statsApi;
